module.exports = __webpack_public_path__ + "img/logo-innovare.12be5e5a.png";